import { Component, h, Prop, Watch, Host } from '@stencil/core';

export interface UiCmsBankSearchBody {
  assetsUrl?: string;
  googleApiKey?: string;
  bankSearchApi?: string;
  formUrl?: string;
  formId?: string;
}
@Component({
  tag: 'ui-cms-bank-search',
  styleUrl: 'ui-cms-bank-search.css',
  shadow: false,
})
export class UiCmsBankSearch {
  @Prop({ mutable: true }) body: UiCmsBankSearchBody = {};

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Prop({ mutable: true }) i18n = {
    skipLink: 'Bankensuche überspringen',
  };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityI18n')
  utilityI18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = JSON.parse(newValue);
  }

  /**
   * Unique ID for the skip link. This is needed because multiple instances of this component can be rendered on the same page.
   */
  private uniqueSkipLink = `skip-bank-search-${crypto.randomUUID()}`;

  componentWillLoad() {
    this.utilityI18nChangeHandler(this.utilityI18n);
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  render() {
    return (
      <Host>
        <div class="sd-hidden-links">
          <sd-button href={`#${this.uniqueSkipLink}`}>{this.i18n.skipLink}</sd-button>
        </div>
        <ui-usercentrics-overlay pid="S1pcEj_jZX">
          <ui-bank-search
            bankSearchApi={this.body.bankSearchApi}
            formUrl={this.body.formUrl}
            formId={this.body.formId}
            assetsUrl={this.body.assetsUrl}
            googleApiKey={this.body.googleApiKey}
            i18n={this.i18n}
          >
            <ui-bank-search-webform-general form-id={this.body.formId}></ui-bank-search-webform-general>
          </ui-bank-search>
        </ui-usercentrics-overlay>
        <div id={this.uniqueSkipLink} class="skip-location" tabindex="-1"></div>
      </Host>
    );
  }
}
